module.exports = __webpack_public_path__ + "img/instalog.fa697060.png";